import {useEffect} from 'react';
import {Platform} from 'react-native';

/**
 * Disables rubber-band/pull-to-refresh on iOS 16+ Safari
 * and stabilizes viewport height using 100dvh.
 * Also sets a solid background color to avoid white flashes.
 */
export default function useIOS16NoBounce(bg: string = '#000') {
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const html = document.documentElement;
    const body = document.body;

    // Save previous inline styles to restore on unmount
    const prev = {
      htmlOSB: html.style.overscrollBehavior,
      bodyOSB: body.style.overscrollBehavior,
      htmlMinH: html.style.minHeight,
      bodyMinH: body.style.minHeight,
      htmlBg: html.style.background,
      bodyBg: body.style.background,
    };

    // Turn off viewport bouncing and pull-to-refresh
    html.style.overscrollBehavior = 'none';
    body.style.overscrollBehavior = 'none';

    // Use dynamic viewport height to avoid toolbar jump
    if ((window as any).CSS?.supports?.('height: 100dvh')) {
      html.style.minHeight = '100dvh';
      body.style.minHeight = '100dvh';
    }

    // Solid background to prevent white flashes during glitches
    html.style.background = bg;
    body.style.background = bg;

    return () => {
      // Restore previous styles
      html.style.overscrollBehavior = prev.htmlOSB;
      body.style.overscrollBehavior = prev.bodyOSB;
      html.style.minHeight = prev.htmlMinH;
      body.style.minHeight = prev.bodyMinH;
      html.style.background = prev.htmlBg;
      body.style.background = prev.bodyBg;
    };
  }, [bg]);
}